import {
  FieldsType,
  IIssueLinkInward,
  IJiraIssue,
  IOpenIssues,
} from "@/models/jiraIssue/jiraIssue.types"
import { Status } from "@/types/Status"

const getStatusHelper = (fields: FieldsType) => {
  const rawColor = fields?.status?.statusCategory?.colorName
  switch (rawColor) {
    case "red":
      return new Status("critical", fields.status.name)
    case "yellow":
      return new Status("caution", fields.status.name)
    case "green":
      return new Status("normal", fields.status.name)
    case "blue":
    case "blue-gray":
    case "water":
    case "default":
      return new Status("neutral", fields.status.name)
    default:
      return new Status("default", fields?.status.name)
  }
}

const createJiraIssueLink = (issueLink?: IIssueLinkInward) => {
  if (!issueLink) return undefined
  return new JiraIssueLink(
    issueLink.id,
    issueLink.key,
    issueLink.self,
    issueLink.fields,
  )
}

const parsedFields = (fields: FieldsType) => {
  if (!fields.issuelinks) {
    return fields
  }

  const issuelinks = fields.issuelinks.map((issueLink) => ({
    ...issueLink,
    inwardIssue: createJiraIssueLink(issueLink.inwardIssue),
    outwardIssue: createJiraIssueLink(issueLink.outwardIssue),
  }))

  return { ...fields, issuelinks }
}

class JiraIssueLink implements IIssueLinkInward {
  id: string
  key: string
  self: string
  fields: FieldsType

  constructor(id: string, key: string, self: string, fields: FieldsType) {
    this.id = id
    this.key = key
    this.self = self
    this.fields = fields
  }

  get status(): Status {
    return getStatusHelper(this.fields)
  }
}

export class JiraIssue implements IJiraIssue {
  expand: string
  fields: FieldsType
  id: string
  key: string
  self: string

  constructor(
    expand: string,
    fields: FieldsType,
    id: string,
    key: string,
    self: string,
  ) {
    this.id = id
    this.key = key
    this.self = self
    this.expand = expand
    this.fields = parsedFields(fields)
  }

  get status(): Status {
    return getStatusHelper(this.fields)
  }
}

export class OpenIncidents implements IOpenIssues {
  issues: IJiraIssue[]
  maxResults: number
  startAt: number
  total: number

  constructor(
    issues: IJiraIssue[],
    maxResults: number,
    startAt: number,
    total: number,
  ) {
    this.issues = issues.map(
      (issue) =>
        new JiraIssue(
          issue.expand,
          issue.fields,
          issue.id,
          issue.key,
          issue.self,
        ),
    )
    this.maxResults = maxResults
    this.startAt = startAt
    this.total = total
  }
}
